import { render, staticRenderFns } from "./HuggingFaceTab.vue?vue&type=template&id=82901e94&scoped=true"
import script from "./HuggingFaceTab.vue?vue&type=script&lang=js"
export * from "./HuggingFaceTab.vue?vue&type=script&lang=js"
import style0 from "./HuggingFaceTab.vue?vue&type=style&index=0&id=82901e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82901e94",
  null
  
)

export default component.exports